import React from "react";
import "./buttonAddHL.css";

const ButtonAddHLPure = (props) => {
  const {
    nameBtn, //Text in btn
    onClickBtn, //Function onClick button
    iconAdd, // True to use plus icon and false to custom icon
    customIcon, //Choose a icon
    disabled, //True to disabled button, false not disabled
  } = props;

  return (
    <button
      disabled={disabled}
      className="buttonAddHLPure-add"
      {...props}
      onClick={(e) => onClickBtn(e)}
    >
      {iconAdd ? (
        <i className={"k-icon k-i-plus buttonAddHLPure-iconPlus-Style"}></i>
      ) : (
        <img src={customIcon} className="buttonAddHLPure-customIcon" />
      )}

      {nameBtn}
    </button>
  );
};

export { ButtonAddHLPure as default };
